module.exports = __webpack_public_path__ + "img/keypal-color-3.782fea74.png";